export default __webpack_public_path__ + "static/more-info-c832863b8823bf7574e287518976c09c.jpg";